import Close from '@mui/icons-material/Close'
import React from 'react'

import { Box, ButtonIcon, Collapsible, GridColDef, Typography } from '../../../../../components'
import { COLORS, styled, Z_INDEX } from '../../../../../theme'
import { ListFieldRowDefinition } from '../../definitions'
import { DrawerDataTable } from './DrawerDataTable'

const StyledCollapsible = styled(Collapsible)`
  z-index: ${Z_INDEX.modal};
  & .MuiDrawer-paper {
    background-color: ${COLORS.primary.contrast};
  }
`

const StyledHeaderBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  justify-content: space-between;
  background-color: ${COLORS.grey50};
  border-bottom: 1px solid ${COLORS.divider};
  color: ${COLORS.text.primary};
`
const StyledContainer = styled(Box)`
  padding: 10px;
`

interface DrawerDataGridProps {
  drawerOpen: boolean
  handleCloseDrawer: () => void
  rows: ListFieldRowDefinition[]
  columns: GridColDef[]
}

export const DrawerDataGrid = ({ drawerOpen, handleCloseDrawer, rows, columns }: DrawerDataGridProps) => {
  return (
    <StyledCollapsible
      // data-test-id="drawer_data_grid"
      anchor="right"
      open={drawerOpen}
      onClose={() => handleCloseDrawer()}
    >
      <StyledHeaderBox>
        <Typography variant="h6">Therapy History</Typography>
        <ButtonIcon data-test-id="drawer_data_grid-close_button" onClick={() => handleCloseDrawer()}>
          <Close />
        </ButtonIcon>
      </StyledHeaderBox>
      <StyledContainer data-test-id="drawer_data_grid-container">
        <DrawerDataTable rows={rows} columns={columns} />
      </StyledContainer>
    </StyledCollapsible>
  )
}
